import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import React from "react";

type ThemeProp = {
    children: JSX.Element
}

export enum themePalette{
    //colores de boton
    BG = "#f3ffd2",
    PINK = "#E994BE",
    //tipografia global
    FONT_GLOBAL = "Jura",
    //colores alerta principal
    ERROR_MAIN = "#f44336",
    BG_ERROR_MAIN= "rgba(244,67,54,0.1)", 
    //success color
    SUCCESS_MAIN = "#66bb6a",
    BG_SUCCESS_MAIN = "rgba(102,200,106,0.5)",
};

const theme = createTheme({
    palette:{
        mode:"light",
        background:{
            default: themePalette.BG,
        },
        primary:{
            main: themePalette.PINK,
        },
    },
    typography:{
        fontFamily: themePalette.FONT_GLOBAL,
    },
    components:{
        MuiButton:{
            defaultProps:{
                style:{
                    textTransform:"none",
                    boxShadow:"none",
                    //borderRadius:"0.5em",
                },
            },
        },
        MuiAlert:{
            defaultProps:{
                style:{
                    borderRadius:"0.8em",
                    fontSize:"1em",
                },
            },
            styleOverrides:{
                standardError:{
                    border:`1px solid ${themePalette.BG_ERROR_MAIN}`,
                    background:themePalette.BG_ERROR_MAIN,
                },
                standardSuccess: {
                    border:`1 px solid ${themePalette.BG_SUCCESS_MAIN}`,
                    background:themePalette.BG_SUCCESS_MAIN,
                },
            },
        },
    },
});

export const ThemeConfig: React.FC<ThemeProp> = ({children}) => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};